<app-page-container 
  [DataTableSchema]="dataTableSchema" [title]="data" [dynamicFormArray]="filterSchema" 
  [props]="props" >
</app-page-container>